import ApiTraining from "./ApiTraining";
export default ApiTraining;
